import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Switch } from 'react-router-dom'
import { Row, Col, message } from 'antd'
import AdminLayout from 'components/elements/AdminLayout'
import SectionContent from 'components/elements/SectionContent'
import SpeciesCards from './SpeciesCards'
import Item from './Item'

import {
  classificationActions
} from 'actions'

class Species extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleCreateButtonOnClick = this.handleCreateButtonOnClick.bind(this)
    this.handleTableOnChange = this.handleTableOnChange.bind(this)
    this.handleOnSelect = this.handleOnSelect.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
  }

  componentDidMount() {
    this.fetch()
  }

  componentDidUpdate(previousProps) {
    if (previousProps.isFetchItemsLoading && this.props.fetchItemsError) {
      message.error(this.props.fetchItemsError)
    }
  }

  fetch() {
    classificationActions.fetch()
  }

  handleCreateButtonOnClick(e) {
    e.preventDefault()
    this.props.history.push(createPath)
  }

  async handleTableOnChange(pagination, filters, sorter) {
    const { columnKey, field, order } = sorter
    await this.props.changeTable({
      pagination,
      filters,
      sorter: {
        columnKey,
        field,
        order,
      },
    })
    this.fetch()
  }

  handleOnSelect(classification) {
    if(classification){
      this.props.history.push(`/admin/species/${classification.id}`)
    }
  }

  handleCreate() {
    this.props.history.push(`/admin/species/new`)
  }

  async handleSearchOnClick() {
    await this.props.searchTable({ isSearching: true })
    await this.props.changeTable({})
    this.fetch()
  }

  async handleSearchOnCancel(e) {
    e.preventDefault()
    await this.props.editSearch({ search: null })
    await this.props.searchTable({ isSearching: false })
    await this.props.changeTable({})
    this.fetch()
  }

  render() {
    
    return (
      <div>
        <AdminLayout>
          <SectionContent noPadding noMargin title='Species'>
          <Switch>
            <Route path='/admin/species' render={()=>
              <Row style={{height: '100%'}}>
                <Col xs={24} lg={8}>
                  <SpeciesCards
                    dataSource={this.props.classifications || []}
                    onSelect={this.handleOnSelect}
                    onCreate={this.handleCreate}
                  />
                </Col>
                <Col xs={24} lg={16}>
                  <Route path='/admin/species/:id'>
                    <Item />
                  </Route>
                </Col>
              </Row>
            }/>
          </Switch>
          </SectionContent>
        </AdminLayout>
      </div>
    )
  }
}

export default withRouter(connect((state)=>(state))(Species))
